import { render, staticRenderFns } from "./RegistrationOverviewCard.vue?vue&type=template&id=9ab28814&"
import script from "./RegistrationOverviewCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports